//
//
//
//
//
//
//
//
//
//
//
//

import { defaultBlockProps } from "~/helpers/data";

export default {
    name: "BowContentStickyMediaDx",

    props: {
        ...defaultBlockProps,

        isActivity: {
            default: false,
            type: Boolean,
        },
    },
};
